import { YolobotSignedUpModalCSS, Close } from './YolobotSignedUpModalCSS.styled'

export const YolobotSignedUpModal = ({ closeModal }) => {
  return (
    <YolobotSignedUpModalCSS>
      <div className='popUpContainer user-signin variable-width'>
        <article>
          <Close name='close2' masking onClick={closeModal} />

          <div className='result_wrapper_mobile'>
            <h1>Success!</h1>
            <div className='yolobot_feature'>
              <div className='yolobot_logo'></div>
              <a id='bot-button' href='https://t.me/yolorektbot' type='button' target='blank' rel='noopener noreferrer'>
                Bid now on <strong>Telegram</strong>
              </a>
              <div className='view_docs'>
                <a href='https://docs.yolorekt.finance/docs/yolobot/quick-start-and-tutorial-guide' target='blank'>
                  YOLOBOT quick-start and tutorial guide
                </a>
              </div>
            </div>
          </div>
        </article>
      </div>
    </YolobotSignedUpModalCSS>
  )
}
